










































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { storePernyataanKenaikanKelas } from "@/store/modules/PernyataanKenaikanKelasStore";
import PernyataanKenaikanKelasSvc from "@/services/PernyataanKenaikanKelas";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { CARA_BAYAR_KELAS_3 } from "@/constants/caraBayarKelas3";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPernyataanKenaikanKelas extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get caraBayarTanpaNaikKelas(): string | null {
    const asr = RegisterKunjungan.register?.asr;
    return (asr && CARA_BAYAR_KELAS_3[asr]) || null;
  }

  get readOnly(): boolean {
    return this.isReadOnly() || !!this.caraBayarTanpaNaikKelas;
  }

  get canSave(): boolean {
    if (this.readOnly) return false;
    const action = this.editingId ? "edit" : "create";
    return userModule.canAccessForm("pernyataan_kenaikan_kelas", action);
  }

  saving = false;
  formValid = false;
  editingId: number | null = null;

  form: any = this.getEmptyForm();

  statusOptions = [
    { text: "Pasien", value: "P" },
    { text: "Suami", value: "S" },
    { text: "Istri", value: "I" },
    { text: "Anak", value: "A" },
    { text: "Orang Tua", value: "O" },
    { text: "Wali", value: "W" }
  ];

  kelasHakOptions = [
    { text: "Kelas 1", value: "1" },
    { text: "Kelas 2", value: "2" },
    { text: "Kelas 3", value: "3" }
  ];

  kelasTujuanOptions = [
    { text: "VIP", value: "VIP" },
    { text: "Kelas 1", value: "1" },
    { text: "Kelas 2", value: "2" }
  ];

  nikRules = [
    (v: string) => !!v || "NIK harus diisi",
    (v: string) => (v && v.length === 16) || "NIK harus 16 digit"
  ];

  onDigitOnlyKeypress(e: KeyboardEvent) {
    if (e.key && e.key.length === 1 && !/\d/.test(e.key)) {
      e.preventDefault();
    }
  }

  onDigitOnlyPaste(e: ClipboardEvent) {
    const data = e.clipboardData ? e.clipboardData.getData("text") : "";
    if (data && /\D/.test(data)) {
      e.preventDefault();
      const cleaned = data.replace(/\D/g, "");
      if (cleaned) {
        document.execCommand("insertText", false, cleaned);
      }
    }
  }

  mounted() {
    storePernyataanKenaikanKelas.getByRegister(this.register);
    this.autoFillPasien();
  }

  @Watch("statePasien")
  onPasienLoaded() {
    if (!this.editingId && this.form.penanda_tangan_status === "P") {
      this.autoFillPasien();
    }
  }

  autoFillPasien() {
    if (this.editingId || this.form.penanda_tangan_status !== "P") return;
    if (this.statePasien) {
      if (this.statePasien.nama) this.form.penanda_tangan_nama = this.statePasien.nama;
      if (this.statePasien.nik) this.form.nik = this.statePasien.nik;
      if (this.statePasien.alamat) this.form.alamat_jalan = this.statePasien.alamat;
    }
    this.fillFromMaster();
  }

  async fillFromMaster() {
    if (!this.register || this.editingId || this.form.penanda_tangan_status !== "P") return;
    const resp = await PernyataanKenaikanKelasSvc.prefill(this.register).catch(() => null);
    const d = resp?.data?.data;
    if (!d) return;
    if (d.nama) this.form.penanda_tangan_nama = d.nama;
    if (d.nik) this.form.nik = String(d.nik);
    if (d.no_kartu_bpjs) this.form.no_kartu_bpjs = String(d.no_kartu_bpjs);
    if (d.kelas_hak) this.form.kelas_hak = d.kelas_hak;
    if (d.alamat_jalan) this.form.alamat_jalan = d.alamat_jalan;
    if (d.alamat_rt) this.form.alamat_rt = d.alamat_rt;
    if (d.alamat_kelurahan) this.form.alamat_kelurahan = d.alamat_kelurahan;
    if (d.alamat_kab_kota) this.form.alamat_kab_kota = d.alamat_kab_kota;
  }

  getEmptyForm() {
    return {
      penanda_tangan_status: "P",
      penanda_tangan_nama: "",
      no_kartu_bpjs: "",
      nik: "",
      alamat_jalan: "",
      alamat_rt: "",
      alamat_no_rumah: "",
      alamat_kelurahan: "",
      alamat_kab_kota: "Bantul",
      kelas_hak: null,
      kelas_tujuan: null,
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate()
    };
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get stateList() {
    return storePernyataanKenaikanKelas.list;
  }

  onStatusChange(val: string) {
    if (val === "P" && this.statePasien) {
      this.form.penanda_tangan_nama = this.statePasien.nama || "";
      this.form.alamat_jalan = this.statePasien.alamat || "";
      this.form.nik = this.statePasien.nik || "";
      this.fillFromMaster();
    } else {
      this.form.penanda_tangan_nama = "";
      this.form.alamat_jalan = "";
      this.form.nik = "";
      this.form.no_kartu_bpjs = "";
    }
  }

  startEdit(item: any) {
    this.editingId = item.id;
    this.form = {
      penanda_tangan_status: item.penanda_tangan_status || "P",
      penanda_tangan_nama: item.penanda_tangan_nama || "",
      no_kartu_bpjs: item.no_kartu_bpjs || "",
      nik: item.nik || "",
      alamat_jalan: item.alamat_jalan || "",
      alamat_rt: item.alamat_rt || "",
      alamat_no_rumah: item.alamat_no_rumah || "",
      alamat_kelurahan: item.alamat_kelurahan || "",
      alamat_kab_kota: item.alamat_kab_kota || "Bantul",
      kelas_hak: item.kelas_hak || null,
      kelas_tujuan: item.kelas_tujuan || null,
      tempat_tanda_tangan: item.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: item.tgl_tanda_tangan || ""
    };
  }

  resetForm() {
    this.editingId = null;
    this.form = this.getEmptyForm();
    this.autoFillPasien();
    this.$nextTick(() => {
      (this.$refs.formPernyataan as any)?.resetValidation();
    });
  }

  cancelEdit() {
    this.resetForm();
  }

  async simpan() {
    if (!(this.$refs.formPernyataan as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form
      };

      let resp;
      if (this.editingId) {
        resp = await PernyataanKenaikanKelasSvc.update(this.editingId, payload);
      } else {
        resp = await PernyataanKenaikanKelasSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Pernyataan Kenaikan Kelas berhasil disimpan");
        this.resetForm();
        storePernyataanKenaikanKelas.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  cetakPdf(id: number) {
    PernyataanKenaikanKelasSvc.print(id);
  }

  async remove(id: number) {
    const q = confirm("Anda yakin akan menghapus pernyataan ini?");
    if (!q) return;

    const resp = await PernyataanKenaikanKelasSvc.destroy(id).catch(() => null);
    if (resp?.status == 1) {
      appModule.NoticeDelay(resp.message);
      storePernyataanKenaikanKelas.getByRegister(this.register);
    }
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }
}
